import { Route } from "react-router-dom";
import {
  HydraAdmin,
  hydraDataProvider as baseHydraDataProvider,
  fetchHydra as baseFetchHydra,
  useIntrospection,
} from "@api-platform/admin";
import { parseHydraDocumentation } from '@api-platform/api-doc-parser';
import authProvider from "./authProvider";
import Login from "./layout/Login";

const entrypoint = process.env.REACT_APP_API_ENTRYPOINT;


const getHeaders = () =>
  localStorage.getItem("token")
    ? {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }
    : {};
const httpClient = (url, options = {}) =>
  baseFetchHydra(url, {
    ...options,
    headers: getHeaders,
  });
const RedirectToLogin = () => {
  const introspect = useIntrospection();

  if (localStorage.getItem("token")) {
    introspect();
    return <></>;
  }
  
  return <></>;
};
const apiDocumentationParser = async () => {
  try {
    //parseHydraDocumentation
    return await parseHydraDocumentation(entrypoint, { headers: getHeaders });
  } catch (result) {
    const { api, response, status } = result;
    if (status !== 401 || !response) {
      throw result;
    }

    // Prevent infinite loop if the token is expired
    localStorage.removeItem("token");

    return {
      api,
      response,
      status,
      customRoutes: [
        <Route key="/" path="/" component={RedirectToLogin} />
      ],
    };
  }
};
const dataProvider = baseHydraDataProvider({
  entrypoint,
  httpClient,
  apiDocumentationParser,
});


const AdminLoader = () => {
  if (typeof window !== "undefined") {
    const { HydraAdmin } = require("@api-platform/admin");
    return <HydraAdmin dataProvider={dataProvider} authProvider={authProvider} entrypoint={entrypoint} />;
  }

  return <></>;
};

const Admin = () => (
  <>
      <title>API Platform Admin</title>

    <AdminLoader />
  </>
);
export default Admin;